
import BaseButton from "@/components/base/BaseButton.vue";
import BaseSection from "@/components/base/BaseSection.vue";
import useAccount from "@/composables/useAccount";
import { Customer } from "@/models/www/store/User";
import { defineComponent, PropType, ref } from "vue";
import AccountSetting from "./AccountSetting.vue";

export default defineComponent({
	components: { BaseSection, AccountSetting, BaseButton },
	props: {
		customer: {
			type: Object as PropType<Customer>,
			required: true,
		},
	},
	setup(props) {
		const { setNewsletterSubscription } = useAccount();
		const isSubscribed = ref(props.customer.newsletter);
		const loading = ref(false);

		const updateSubscription = (subscribe: boolean) => {
			loading.value = true;
			setNewsletterSubscription(subscribe)
				.then(() => {
					isSubscribed.value = subscribe;
				})
				.finally(() => (loading.value = false));
		};

		return {
			isSubscribed,
			updateSubscription,
			loading
		};
	},
});
